function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.041 3.5a3 3 0 015.918 0H20.5A1.5 1.5 0 0122 5h3a2 2 0 012 2v22a2 2 0 01-2 2H7a2 2 0 01-2-2V7a2 2 0 012-2h3a1.5 1.5 0 011.5-1.5h1.541zM16 3a1 1 0 011 1 1 1 0 001 1h1.5a.5.5 0 01.5.5v.4a.1.1 0 01-.1.1h-7.8a.1.1 0 01-.1-.1v-.4a.5.5 0 01.5-.5H14a1 1 0 001-1 1 1 0 011-1zm-6 4a1 1 0 001 1h10a1 1 0 001-1h2.5a.5.5 0 01.5.5v21a.5.5 0 01-.5.5h-17a.5.5 0 01-.5-.5v-21a.5.5 0 01.5-.5H10z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.141 14H22.5l-2.925 8.877-.171.123h-1.11l-.172-.123-1.849-5.611h1.358l.172.123 1.044 3.172 2.123-6.438.171-.123zm-5.695 0h1.357l-2.925 8.877-.17.123h-1.36l2.926-8.877.172-.123zm-4.587 0l.171.123 1.848 5.61H11.52l-.171-.123L9.5 14h1.359z",
  fill: "currentColor"
})));